/**
 * Dummy page for /school/devops route
 *
 * This file exists to prevent SEO issues caused by 404 responses for HEAD requests.
 *
 * HEAD requests to /school/devops are reaching Next.js directly without proper
 * reverse proxy routing through the Cloudflare Worker, causing them to hit the
 * legacy [slug].tsx route which returns 404 because "devops" is not in the
 * legacySchoolSlugs whitelist.
 *
 * This dummy page provides a 200 response for SEO purposes, ensuring search engines
 * don't penalize the site for returning 404s on what should be valid school pages.
 * The page returns null (no content) but responds with 200 status.
 *
 * TODO: Remove file when we move all school pages to the new design.
 */
export default function DevOpsSchoolPage() {
  return null;
}
